import request from 'sb-request'
import { getState, reducers } from 'redux/core'
import { array, constants } from 'common/helpers'

import bestsellersBrandsQuery from './bestsellersBrands.graphql'
import productsQuery from './products.graphql'


// for mobiles only
const openCategoriesOverlay = () => reducers.models.products.setCategoriesOverlayVisibility(true)
const closeCategoriesOverlay = () => reducers.models.products.setCategoriesOverlayVisibility(false)

const openFiltersOverlay = (initialActiveFilter = null) => {
  reducers.models.products.setFiltersOverlayInitialFilter(initialActiveFilter)
  reducers.models.products.setFiltersOverlayVisibility(true)
}

const closeFiltersOverlay = () => {
  reducers.models.products.setFiltersOverlayVisibility(false)
  reducers.models.products.setFiltersOverlayInitialFilter(null)
}

const setFetching = (value) => reducers.models.products.setFetching(value)

const fetchBrands = (gender) =>
  request.post('graphql?name=bestsellersBrands', {
    body: {
      query: bestsellersBrandsQuery,
      variables: {
        input: {
          category: 'bestsellers',
          groups: [ 'Perfume', 'BathBody', 'Makeup' ],
          gender,
        },
      },
    },
    modifyResult: ({ brands }) => brands.map(({ name, count }) => ({
      label: name,
      value: name,
      count,
    })),
  })
    .then((brands) => reducers.models.products.setBrands(brands))

const requestProductsGql = (params) => {
  const { models: { products: { activeFilters: { brands } } } } = getState()

  if (brands.length) {
    params.brands = brands
  }

  setFetching(true)

  request.post('graphql?name=products', {
    body: {
      query: productsQuery,
      variables: {
        input: params,
      },
    },
    modifyResult: ({ products = [] }) => products,
  })
    .then(
      (products) => {
        reducers.models.products.setProducts(products)
        reducers.models.products.setProductCount(products.length)
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

const fetchNewScentbird = (gender) => requestProductsGql({
  category: 'newarrivals',
  groups: [ 'Perfume', 'BathBody', 'HomeFragrance', 'CandleSet', 'Makeup', 'PersonalCare' ],
  brand: 'Scentbird',
  gender,
})

const fetchScentbird = (gender) => requestProductsGql({
  productsFeed: constants.productsFeed.scentbirdProducts,
  groups: [ 'Perfume', 'BathBody', 'HomeFragrance', 'CandleSet', 'Makeup', 'PersonalCare' ],
  brand: 'Scentbird',
  gender,
})

const fetchCandles = () => requestProductsGql({
  productsFeed: constants.productsFeed.candles,
  groups: [ 'HomeFragrance' ],
})

const fetchBestsellersProducts = (gender) => requestProductsGql({
  productsFeed: constants.productsFeed.bestsellersMain,
  category: 'bestsellers',
  groups: [ 'Perfume', 'BathBody', 'Makeup' ],
  gender,
})

const fetchMakeupProductsByBrand = (brand) => () => requestProductsGql({
  groups: [ 'Makeup' ],
  brand,
})

const fetchRecommendations = ({ gender, limit = 12 }) => {
  setFetching(true)

  return request.get('rest/shop/recommendations', {
    query: {
      gender,
      limit,
    },
  })
    .then(
      ({ perfumes }) => {
        reducers.models.products.setProducts(perfumes)
        reducers.models.products.setProductCount(perfumes.length)

        return perfumes
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

const fetchPopularByGender = (params) => {
  const { gender, limit = 72, offset = 0, randomLimit = 0, notes } = params

  setFetching(true)

  const input = {
    gender,
    limit,
    offset,
    notes,
    groups: [ 'Perfume' ],
    sorts: [ 'TOTAL_PURCHASES' ],
    availableForQueue: true,
  }

  return request.post('graphql?name=fetchPopularByGender', {
    body: {
      query: productsQuery,
      variables: {
        input,
      },
    },
    modifyResult: ({ products }) => {
      if (randomLimit > 0) {
        return array.shuffle(products).slice(0, randomLimit)
      }
      return products
    },
  })
    .then(
      (products) => {
        reducers.models.products.setProducts(products)
        reducers.models.products.setProductCount(products.length)

        return products
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

/**
 *
 * @param {String} label
 */
const toggleActiveBrand = (label) => reducers.models.products.toggleActiveBrand(label)

const clearProducts = () => reducers.models.products.clearProducts()

const clearFilters = () => reducers.models.products.clearFilters()

const clearFilter = (filter) => reducers.models.products.clearFilter(filter)

const setActiveFilter = ({ activeFilter, value }) => reducers.models.products.setActiveFilter({ activeFilter, value })

const toggleActiveFilter = ({ activeFilter, value }) => reducers.models.products.toggleActiveFilter({ activeFilter, value })

const addFilterValue = ({ filter, value }) => reducers.models.products.addFilterValue({ filter, value })

const removeFilterValue = ({ filter, value }) => reducers.models.products.removeFilterValue({ filter, value })


export default {
  openCategoriesOverlay,
  closeCategoriesOverlay,
  openFiltersOverlay,
  closeFiltersOverlay,

  setFetching,

  fetchBrands,
  fetchNewScentbird,
  fetchScentbird,
  fetchCandles,
  fetchBestsellersProducts,
  fetchMakeupProductsByBrand,
  fetchRecommendations,
  fetchPopularByGender,

  clearFilters,
  clearProducts,
  clearFilter,

  toggleActiveBrand,
  setActiveFilter,
  toggleActiveFilter,
  addFilterValue,
  removeFilterValue,
}
